import { CommonApplicationResponse } from '@src/features/common-application/types/common-application';
import { api } from '@src/lib/api-client';
import { QueryConfig } from '@src/lib/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

export async function getCommonApplication(): Promise<CommonApplicationResponse> {
  const response = await api.get<CommonApplicationResponse>(
    '/api/v3/user/common-applications',
  );
  return response.data;
}

export const getCommonApplicationQueryOptions = queryOptions({
  queryKey: ['common-application'],
  queryFn: getCommonApplication,
});

type UseGetCommonApplicationOptions = {
  queryConfig?: QueryConfig<typeof getCommonApplicationQueryOptions>;
};

export const useGetCommonApplication = ({
  queryConfig,
}: UseGetCommonApplicationOptions = {}) => {
  return useSuspenseQuery({
    ...getCommonApplicationQueryOptions,
    ...queryConfig,
  });
};
